import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { usePDF } from 'react-to-pdf';
import styled from 'styled-components';
import PdfResume from './PdfResume';

const PdfButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 1000;
  font-size: 24px;

  &:hover {
    background-color: #2980b9;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  }
`;

const PdfContainer = styled.div`
  position: absolute;
  left: -9999px;
`;

const PdfExport = () => {
  const { t, i18n } = useTranslation();
  const targetRef = useRef();
  const { toPDF, targetRef: pdfTargetRef } = usePDF({
    filename: `Ali_Omer_Simsek_CV_${i18n.language}.pdf`,
    page: { 
      margin: 15,
      format: 'A4',
      orientation: 'portrait'
    },
    canvas: {
      mimeType: 'image/png',
      qualityRatio: 1
    }
  });

  return (
    <>
      <PdfButton onClick={() => toPDF()} title={t('downloadPdf', 'Download PDF')}>
        CV
      </PdfButton>
      <PdfContainer>
        <div ref={targetRef}>
          <PdfResume ref={pdfTargetRef} />
        </div>
      </PdfContainer>
    </>
  );
};

export default PdfExport;
